// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"a80f74ec05a37b89","2013":"f702c3594d66d0b6","3807":"4874e4271221d1da","9099":"320428ae2ad86c47"}[chunkId] + ".js";
};